import { FormControl, ValidationErrors } from "@angular/forms";
import { validateEmail } from "../../utils/string";
export function validateChips(c: FormControl): ValidationErrors | null {
	let invalid = c?.value?.some((email: string) => !validateEmail(email));
	if (invalid) {
		return { containsInvalidEmail: true };
	}
	return null;
}
